export const iframeMapper = ({ iframeTitle, ...rest }) => ({
  title: iframeTitle,
  ...rest,
});
